<template>
<div class="card">
    <div class="card-header">Re-Posted</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>

        <b-form @submit.stop.prevent="onSubmit">
            <b-row>
                <b-col>
                    <LifecycleCheckList lifecycleStatus="14" :requestId="request.id"
                        v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" lg="6">                    
                    <BaseDateInput v-model="request.repostingOpenDate" 
                        :v="$v.request.repostingOpenDate"
                        label="Re Posting Open Date"
                        slug="open-date"
                        required='true'/>
                </b-col>
                <b-col cols="12" lg="6">
                    <BaseDateInput v-model="request.repostingCloseDate" 
                            :v="$v.request.repostingCloseDate"
                            label="Re Posting Close Date"
                            slug="close-date"
                            required='true'/> 
                </b-col>
            </b-row>

            <b-row style="margin-bottom:20px;">
                <b-col>
                    <b-form-checkbox v-model="repost" name="repost-switch" data-test="repost-switch" switch>
                        <b>Repost Position</b>
                    </b-form-checkbox>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <BaseParagraphInput v-model="comments"
                        :v="$v.comments" 
                        slug="repostingComments"
                        label="Internal Comments"
                        :required="$v.comments.$params.required"/>
                </b-col>
            </b-row>
            
            <div>
            <b-button type="submit" variant="primary">Complete Re-Posting</b-button>
            <b-button type="button" variant="outline-primary" @click="save">Save</b-button>
            </div>
        </b-form>
    </div>
</div>

</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, numeric } from 'vuelidate/lib/validators'
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'

export default {
    components: {
        LifecycleCheckList,
    },
    props: {
        request: Object
    },
    data() {
        return {
            checklistComplete: false,
            comments: '',
            repost: false,
            saveOnly: false,
        }
    },
     validations: {
         checklistComplete: { checked: value => value === true },
         comments: { required: false },
         request: {    
             repostingOpenDate: { required },
             repostingCloseDate: { required },
        }
     },
    methods: {
        updateChecklistStatus(b) {
            this.checklistComplete = b
        },
        save() {
            this.saveOnly = true
            this.onSubmit()
            this.saveOnly = false
        },
        onSubmit() {
            if (!this.saveOnly) {
                this.$refs.checklist.emitCheckListStatus()
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$nextTick(() => {
                        document.getElementById('form-container').scrollIntoView()
                    })
                    return
                }
            }

            let payload = {
                requestId: this.request.id,
                comments: this.comments, 
                repostingOpenDate: this.request.repostingOpenDate,
                repostingCloseDate: this.request.repostingCloseDate,
                nextLifecycle: this.repost ? '14' : '09',
                advanceNextLifecycle: !this.saveOnly,
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/reposted`, payload)
                  .then(response => { 
                    this.showRootToast("HRM Request Has Been Updated", "Success", "success")
                    if (payload.advanceNextLifecycle === true) {
                        this.$router.push('/home')
                    } 
                  })         
        },
        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },
    }   
}
</script>